<template>
	<div class='footer'>
		<p class='footer__text'>
			<span v-if="lang === 'en'">published 2020
			</span>
			<span v-else>publicado 2020</span>
		</p>
		<p class='footer__bar'>|</p>
		<p class='footer__text'>
			<span v-if="lang === 'en'">all rights reserved
			</span>
			<span v-else>todos los derechos reservados</span>
		</p>
		<p class='footer__bar'>|</p>
		<p class='footer__text'>
			<span v-if="lang === 'en'">designed and built by </span>
			<span v-else>diseñado y construido por </span>
			<a class='footer__link' :href='linkUrl'>{{ linkText }}</a></p>
	</div>

</template>


<script>
	
	export default {
		props: {
			lang: String
		},
		computed: {
			linkText() {
				return window.location.href.includes('againwewander') ? 'againwewander' : 'north third'
			},
			linkUrl() {
				return window.location.href.includes('againwewander') ? 'https://againwewander.com' : 'https://norththird.io'
			}
		}
	}

</script>